"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCategoryDetails = exports.useCategoryChildrenList = exports.useCategoryAncestorsList = exports.useCategoryList = void 0;

var CategoryDetails_1 = require("../../api/categories/CategoryDetails");

var CategoryAncestorsList_1 = require("../../api/categories/CategoryAncestorsList");

var CategoryChildrenList_1 = require("../../api/categories/CategoryChildrenList");

var CategoryList_1 = require("../../api/categories/CategoryList");

var utils_1 = require("./utils");

exports.useCategoryList = utils_1.makeList(function (client) {
  return new CategoryList_1.CategoryList(client);
});
exports.useCategoryAncestorsList = utils_1.makeList(function (client) {
  return new CategoryAncestorsList_1.CategoryAncestorsList(client);
});
exports.useCategoryChildrenList = utils_1.makeList(function (client) {
  return new CategoryChildrenList_1.CategoryChildrenList(client);
});
exports.useCategoryDetails = utils_1.makeDetails(function (client) {
  return new CategoryDetails_1.CategoryDetails(client);
});